export default __webpack_public_path__ + "static/media/logo-animation-light.78e512e1.gif";